import { CaretDown, CaretUp } from '@phosphor-icons/react'
import {
  ButtonV4,
  type ButtonV4Props,
} from '@tokenterminal/ui/Button/Button.v4'
import { type ButtonHTMLAttributes, forwardRef, type ReactNode } from 'react'
import { type BoxProps } from '../../Box'
import {
  type ButtonProps as ButtonV3Props,
  ButtonV3,
} from '../../Button/Button.v3'
import { Icon } from '../../Icon'
import { Stack } from '../../Stack'
import { caretShiftCss } from './Button.css'

type ButtonPropsBase = {
  children: ReactNode
  disabled: boolean
  onClick: ButtonHTMLAttributes<HTMLButtonElement>['onClick']
  onKeyDown: ButtonHTMLAttributes<HTMLButtonElement>['onKeyDown']
  isOpen: boolean
  width: BoxProps['width']
}

type ButtonPropsV3 = {
  version?: '3'
  size?: ButtonV3Props['size']
  variant?: ButtonV3Props['variant']
}

type ButtonPropsV4 = {
  version: '4'
  size?: ButtonV4Props['size']
  variant?: ButtonV4Props['variant']
}

type ButtonProps = ButtonPropsBase &
  (ButtonPropsV3 | ButtonPropsV4) & { version?: '3' | '4' }

/** @deprecated */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button({ children, isOpen, version, ...props }, buttonRef) {
    const buttonChildrenV3 = [
      children,
      <Stack key="icons" gap="none">
        <Icon as={CaretUp} width="8" height="8" />
        <Icon as={CaretDown} width="8" height="8" className={caretShiftCss} />
      </Stack>,
    ]

    const buttonChildrenV4 = [children, <Icon as={CaretDown} />]

    if (version === '3') {
      return (
        <ButtonV3
          ref={buttonRef}
          aria-haspopup="listbox"
          aria-expanded={isOpen ? 'true' : 'false'}
          {...(props as ButtonPropsBase & ButtonPropsV3)}
        >
          {buttonChildrenV3}
        </ButtonV3>
      )
    }

    return (
      <ButtonV4
        ref={buttonRef}
        aria-haspopup="listbox"
        aria-expanded={isOpen ? 'true' : 'false'}
        {...(props as ButtonPropsBase & ButtonPropsV4)}
      >
        {buttonChildrenV4}
      </ButtonV4>
    )
  },
)
